import Vue from 'vue'
import cpExcluidos from "@/plugins/codigosPostalesExcluidos.js";

const bus = new Vue({
    data () {
        return {
            login: false,
            pConsulta: {
                buscadorOrden: '', //aqui se guarda el codigo por el que se va a buscar como 'TELEFONICA0001'
                datosOrden: {}, //se guarda los datos de la orden que se encuentra o no 
                mensajeError: '' //mensaje de Error en caso de que lo hubiera
            },
            datosUsuario: undefined,
            //Entidades para desplegables
            CPs: [],
            embalajes: [],
            modelos: [],
            fabricantes: [],
            sintomas: [],
            accesorios: [],
            //JSONs para envio de datos
            resultadosAPI: {
                ordenCreada: '',
                subirFactura: '',
                generarExpedicion: ''
            },
            formulario: {
                company: false,
                empresaSinRegistrar: false,
                codigoEmpresa: "",
                igualEntrega: true,
                facturaCompleta: false,
                igualFacturacion: true,
                recogida: {
                    name: '',
                    telephone: '',
                    mail: '',
                    cif: '',
                    company: '',

                    country: 'ES',
                    zipcode: '',
                    address: '',
                    town: '',
                    province: '',
                    tienda: null,
                    enTienda: false,

                    nameError: '',
                    cifError: '',
                    telephoneError: '',
                    mailError: '',
                    zipcodeError: '',
                    addressError: '',
                    companyError: ''
                },
                facturacion: {
                    zipcode: '',
                    address: '',
                    town: '',
                    province: '',

                    zipcodeError: '',
                    addressError: ''
                },
                entrega: {
                    country: 'ES',
                    zipcode: '',
                    address: '',
                    town: '',
                    province: '',

                    zipcodeError: '',
                    addressError: ''
                },
                horario: {
                    fechaRecogida: '',
                    fechaError: ''
                },
                dispositivo: {
                    tipo: 0,
                    fabricante: 0,
                    model: '',
                    noModelo: false,
                    model2: '',
                    sn: '',
                    symptom: 0,
                    symptom_description: '',
                    accesories: [],

                    tipoError: '',
                    fabricanteError: '',
                    modelError: '',
                    model2Error: '',
                    snError: '',
                    symptomError: '',
                    symptom_descriptionError: '',
                    accesoriesError: ''
                },
                especiales: {
                    embalaje: false,
                    package: 0,
                    invoice: [],
                    invoiceName: [],
                    prescriptor: '',
                    terminos: false,

                    embalajeError: '',
                    terminosError: '',
                    prescriptorError: ''
                },
                hasErrors: false
            },
            jsonFactura: {},
            //Datos para errores
            errores: {
                nombreVacio: 'El nombre de remitente es un dato obligatorio',
                nombreIncompleto: 'El nombre del remitente está incompleto',
                telefonoVacio: 'El telefono del remitente es un dato obligatorio',
                telefonoFormato: 'El formato del telefono no es correcto, 9 cifras numéricas',
                emailVacio: 'El correo electrónico del remitente es una dato obligatorio',
                emailFormato: 'El correo electrónico no es un correo válido',
                empresaVacio: 'La empresa de remitente es un dato obligatorio',
                empresaMaxExcedida: 'La empresa excede el número máximo de 40 caracteres, por favor, intente acortarla',
                dniVacio: 'El dni/cif del remitente es un dato obligatorio',
                cpVacio: 'Debe indicar el código postal',
                cpFuera: 'En Canarias, Ceuta y Melilla, únicamente se da cobertura a dispositivos del Fabricante DELL',
                cpZeleris: 'El código postal proporcionado no es válido, más información en el siguiente teléfono: 902 16 26 46',
                direccionVacio: 'La dirección de remitente es un dato obligatorio',
                direccionMaxExcedida: 'La dirección excede el número máximo de 40 caracteres',
                fechaIncorrecta: 'La fecha de recogida es un dato obligatorio',
                fechaAnterior: 'La fecha de recogida tiene que ser posterior a hoy',
                snVacio: 'El número de serie del dispositivo es un dato obligatorio',
                tipoVacio: 'El tipo del dispositivo es un dato obligatorio',
                fabricanteVacio: 'El fabricante del dispositivo es un dato obligatorio',
                modeloVacio: 'El modelo del dispositivo es un dato obligatorio',
                modelo2Vacio: 'Debe escribir el modelo del dispositivo',
                sintomaVacio: 'La descripción del problema del dispositivo es obligatorio',
                idSintomaVacio: 'El síntoma del dispositivo es obligatorio',
                embalajeSinSeleccionar: 'Si necesita embalaje, debe seleccionar una de las opciones',
                terminosNoAceptados: 'No se han aceptado las Condiciones generales'
            }
        }
    },
    computed: {
        esParticularSinRegistro() { return !this.login && !this.formulario.empresaSinRegistrar && !this.formulario.company }
    },
    methods: {
        getCodigosPostales() {
            if (this.CPs.length == 0) {
                this.$API.postCodes().then(response => {
                    if (response != '') this.CPs = response.CPs
                })
            }
        },
        vaciarErrores() {
            Object.entries(this.formulario.recogida).forEach(([key, value]) => {
                if (key.includes('Error') && key != 'cifError') this.formulario.recogida[key] = ''
            })
            Object.entries(this.formulario.entrega).forEach(([key, value]) => {
                if (key.includes('Error') && key != 'cifError') this.formulario.entrega[key] = ''
            })
            Object.entries(this.formulario.facturacion).forEach(([key, value]) => {
                if (key.includes('Error')) this.formulario.facturacion[key] = ''
            })
            Object.entries(this.formulario.horario).forEach(([key, value]) => {
                if (key.includes('Error')) this.formulario.horario[key] = ''
            })
            Object.entries(this.formulario.dispositivo).forEach(([key, value]) => {
                if (key.includes('Error')) this.formulario.dispositivo[key] = ''
            })
            Object.entries(this.formulario.especiales).forEach(([key, value]) => {
                if (key.includes('Error')) this.formulario.especiales[key] = ''
            })
            this.formulario.hasErrors = false;
        },
        limpiarDatosEmpresa() {
            this.login = false
            this.formulario.company = false
            this.formulario.codigoEmpresa = ''
            this.formulario.recogida.enTienda = false
            this.formulario.recogida.name = ''
            this.formulario.recogida.telephone = ''
            this.formulario.recogida.mail = ''
            this.formulario.recogida.country = 'ES'
            this.formulario.recogida.town = ''
            this.formulario.recogida.zipcode = ''
            this.formulario.recogida.address = ''
            this.formulario.recogida.province = ''
            this.formulario.recogida.company = ''
            this.formulario.recogida.tienda = null
            this.formulario.entrega.country = 'ES'
            this.formulario.recogida.town = ''
            this.formulario.entrega.zipcode = ''
            this.formulario.entrega.address = ''
            this.formulario.entrega.province = ''
        },
        comprobarNombreRegistrado() {
            if (this.formulario.recogida.name == "") {
                this.formulario.recogida.nameError = this.errores.nombreVacio;
                this.formulario.hasErrors = true
            } else if (!this.formulario.company && this.formulario.recogida.name.split(" ").length < 2) {
                this.formulario.recogida.nameError = this.errores.nombreIncompleto;
                this.formulario.hasErrors = true
            }
        },
        comprobarTelefonoRegistrado() {
            if (this.formulario.recogida.telephone == "") {
                this.formulario.recogida.telephoneError = this.errores.telefonoVacio;
                this.formulario.hasErrors = true
            } else if (!/^[0-9]{9}/.test(this.formulario.recogida.telephone)) {
                this.formulario.recogida.telephoneError = this.errores.telefonoFormato;
                this.formulario.hasErrors = true
            }
        },
        comprobarEmailRegistrado() {
            if (this.formulario.recogida.mail == "") {
                this.formulario.recogida.mailError = this.errores.emailVacio;
                this.formulario.hasErrors = true
            } else if (!this.formulario.recogida.mail.includes("@") || !this.formulario.recogida.mail.includes(".")) {
                this.formulario.recogida.mailError = this.errores.emailFormato;
                this.formulario.hasErrors = true
            }
        },
        comprobarCifRegistrado() {
            if (!this.formulario.company && this.formulario.recogida.cif == "") {
                this.formulario.recogida.cifError = this.errores.dniVacio;
                this.formulario.hasErrors = true
            }
        },
        comprobarCPRegistrado() {
            if (cpExcluidos.includes(this.formulario.recogida.zipcode) && this.formulario.dispositivo.fabricante != 216) {
                this.formulario.recogida.zipcodeError = this.errores.cpFuera;
                this.formulario.hasErrors = true
            }
            if (this.formulario.recogida.zipcode == "") {
                this.formulario.recogida.zipcodeError = this.errores.cpVacio;
                this.formulario.hasErrors = true
            }
        },
        comprobarDireccionRegistrado() {
            if (this.formulario.recogida.address == "") {
                this.formulario.recogida.addressError = this.errores.direccionVacio;
                this.formulario.hasErrors = true
            }
            if (this.formulario.recogida.address.length > 40) {
                this.formulario.recogida.addressError = this.errores.direccionMaxExcedida;
                this.formulario.hasErrors = true
            }
        },
        //comprobarNombreEmpresa() {
        //    if (!this.formulario.igualEntrega) {
        //        if (this.formulario.entrega.name == "") {
        //            this.formulario.entrega.nameError = this.errores.nombreVacio;
        //            this.formulario.hasErrors = true
        //        } else if (this.formulario.entrega.name.split(" ").length < 2) {
        //            this.formulario.entrega.nameError = this.errores.nombreIncompleto;
        //            this.formulario.hasErrors = true
        //        }
        //    }
        //},
        //comprobarTelefonoEmpresa() {
        //    if (!this.formulario.igualEntrega) {
        //        if (this.formulario.entrega.telephone == "") {
        //            this.formulario.entrega.telephoneError = this.errores.telefonoVacio;
        //            this.formulario.hasErrors = true
        //        } else if (!/^[0-9]{9}/.test(this.formulario.entrega.telephone)) {
        //            this.formulario.entrega.telephoneError = this.errores.telefonoFormato;
        //            this.formulario.hasErrors = true
        //        }
        //    }
        //},
        //comprobarEmailEmpresa() {
        //    if (!this.formulario.igualEntrega) {
        //        if (this.formulario.entrega.mail == "") {
        //            this.formulario.entrega.mailError = this.errores.emailVacio;
        //            this.formulario.hasErrors = true
        //        } else if (!this.formulario.entrega.mail.includes("@") || !this.formulario.entrega.mail.includes(".")) {
        //            this.formulario.entrega.mailError = this.errores.emailFormato;
        //            this.formulario.hasErrors = true
        //        }
        //    }
        //},
        //comprobarCifEmpresa() {
        //    if (!this.formulario.igualEntrega && !this.formulario.company && this.formulario.entrega.cif == "") {
        //        this.formulario.entrega.cifError = this.errores.dniVacio;
        //        this.formulario.hasErrors = true
        //    }
        //},
        comprobarCPEmpresa() {
            if (!this.formulario.igualEntrega) {
                if (cpExcluidos.includes(this.formulario.entrega.zipcode)) {
                    this.formulario.entrega.zipcodeError = this.errores.cpFuera;
                    this.formulario.hasErrors = true
                }
                if (this.formulario.entrega.zipcode == "") {
                    this.formulario.entrega.zipcodeError = this.errores.cpVacio;
                    this.formulario.hasErrors = true
                }
            }
        },
        comprobarDireccionEmpresa() {
            if (!this.formulario.igualEntrega && this.formulario.entrega.address == "") {
                this.formulario.entrega.addressError = this.errores.direccionVacio;
                this.formulario.hasErrors = true
            }
        },
        comprobarEmpresaRegistrada() {
            if (this.formulario.empresaSinRegistrar && this.formulario.recogida.company == "") {
                this.formulario.recogida.companyError = this.errores.empresaVacio;
                this.formulario.hasErrors = true
            }
            if (this.formulario.recogida.company.length > 40) {
                this.formulario.recogida.companyError = this.errores.empresaMaxExcedida;
                this.formulario.hasErrors = true
            }
        },
        comprobarFecha() {
            if (!this.formulario.recogida.enTienda) {
                if (this.formulario.horario.fechaRecogida == "") {
                    this.formulario.horario.fechaError = this.errores.fechaIncorrecta;
                    this.formulario.hasErrors = true
                }
                if (new Date(this.formulario.horario.fechaRecogida) < new Date()) {
                    this.formulario.horario.fechaError = this.errores.fechaAnterior;
                    this.formulario.hasErrors = true
                }
            }
        },
        comprobarTipoModelo() {
            if (this.formulario.dispositivo.tipo == 0) {
                this.formulario.dispositivo.tipoError = this.errores.tipoVacio;
                this.formulario.hasErrors = true
            }
        },
        comprobarFabricante() {
            if (this.formulario.dispositivo.fabricante == 0) {
                this.formulario.dispositivo.fabricanteError = this.errores.fabricanteVacio;
                this.formulario.hasErrors = true
            }
        },
        comprobarModelo() {
            if (!this.formulario.dispositivo.noModelo && this.formulario.dispositivo.model == "") {
                this.formulario.dispositivo.modelError = this.errores.modeloVacio;
                this.formulario.hasErrors = true
            }
            if (this.formulario.dispositivo.noModelo && this.formulario.dispositivo.model2 == "") {
                this.formulario.dispositivo.model2Error = this.errores.modelo2Vacio;
                this.formulario.hasErrors = true
            }
        },
        comprobarSintoma() {
            if (this.formulario.dispositivo.symptom == "") {
                this.formulario.dispositivo.symptomError = this.errores.idSintomaVacio;
                this.formulario.hasErrors = true
            }
            if (this.formulario.dispositivo.symptom_description == "") {
                this.formulario.dispositivo.symptom_descriptionError = this.errores.sintomaVacio;
                this.formulario.hasErrors = true
            }
        },
        comprobarEmbalaje() {
            if (this.formulario.especiales.embalaje && this.formulario.especiales.package == 0) {
                this.formulario.especiales.embalajeError = this.errores.embalajeSinSeleccionar;
                this.formulario.hasErrors = true
            }
        },
        comprobarTerminos() {
            if (!this.formulario.especiales.terminos) {
                this.formulario.especiales.terminosError = this.errores.terminosNoAceptados;
                this.formulario.hasErrors = true
            }
        },
        comprobarFacturacionDireccion() {
            if (!this.formulario.igualFacturacion) {
                if (this.formulario.facturacion.address == "") {
                    this.formulario.facturacion.addressError = this.errores.direccionVacio;
                    this.formulario.hasErrors = true
                }
                if (this.formulario.facturacion.address.length > 40) {
                    this.formulario.facturacion.addressError = this.errores.direccionMaxExcedida;
                    this.formulario.hasErrors = true
                }
            }
        },
        comprobarFacturacionCP() {
            if (!this.formulario.igualFacturacion) {
                if (cpExcluidos.includes(this.formulario.facturacion.zipcode)) {
                    this.formulario.facturacion.zipcodeError = this.errores.cpFuera;
                    this.formulario.hasErrors = true
                }
                if (this.formulario.facturacion.zipcode == "") {
                    this.formulario.facturacion.zipcodeError = this.errores.cpVacio;
                    this.formulario.hasErrors = true
                }
            }
        },
        validarFormulario() {
            this.vaciarErrores();

            this.comprobarNombreRegistrado();
            this.comprobarTelefonoRegistrado();
            this.comprobarEmailRegistrado();
            this.comprobarCPRegistrado();
            this.comprobarDireccionRegistrado();
            this.comprobarCifRegistrado();
            this.comprobarEmpresaRegistrada();
            this.comprobarFacturacionDireccion();
            this.comprobarFacturacionCP();

            //this.comprobarNombreEmpresa();
            //this.comprobarTelefonoEmpresa();
            //this.comprobarEmailEmpresa();
            //this.comprobarCifEmpresa();
            this.comprobarCPEmpresa();
            this.comprobarDireccionEmpresa();

            this.comprobarFecha();
            this.comprobarTipoModelo();
            this.comprobarFabricante();
            this.comprobarModelo();
            this.comprobarSintoma();
            this.comprobarEmbalaje();
            this.comprobarTerminos();

            return !this.formulario.hasErrors;
        },
    }
})

export default {
    install (Vue) {
        Vue.prototype.$bus = bus
    }
}